import { Component, Input } from '@angular/core'

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'confirmation',
    templateUrl: 'confirmation.modal.html',
    styleUrls: ['./style/modal.scss'],
    standalone: false
})
export class ConfirmationModal {
    @Input() title = "Title";
    @Input() body = "";
    @Input() extra?: string;
    @Input() cssClass?: string = "info";

    constructor(public activeModal: NgbActiveModal) { }
}